export default __webpack_public_path__ + "static/rule-02-tape-fit-49b0a4a76ec6f5340dc949ec5cfb95ba.png";